// Assignment validation constants
export const COMMENTS_REQUIRED = true;
export const MIN_COMMENTS_LENGTH = 1; 